module.exports = __webpack_public_path__ + "c0638bea87a05fdfa2bb3bba2efe54e4.woff";